import useWebSocket from 'react-use-websocket';

// "undefined" means the URL will be computed from the `window.location` object
const URL = `${process.env.REACT_APP_WEBSOCKET_URI || ''}${process.env.REACT_APP_WEBSOCKET_PATH || ''}`;

export const useSocket = (token: string) => {
  const t = (token || '').substring(7);
  return useWebSocket(`${URL}?t=${t}&u=business`)
};